// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._yv0eloeq{grid-template-columns:repeat(7,minmax(max-content,1fr))}", ""]);
// Exports
module.exports = exports;
